import type { TranscribeResponse } from './const';
import { agentsRequest } from '../request';
import { TRANSCRIBE_TIMEOUT } from './const';

/**
 * 上传音频并获取转写结果
 * @param audioBlob 音频 Blob
 * @param signal 可选的 AbortSignal
 * @returns 转写响应
 */
export async function transcribeSpeech(
  audioBlob: Blob,
  signal?: AbortSignal,
): Promise<TranscribeResponse> {
  const formData = new FormData();
  formData.append('audio', audioBlob, `recording-${Date.now()}.webm`);

  const response = await agentsRequest.post<TranscribeResponse>('/speech/transcribe', formData, {
    signal,
    timeout: TRANSCRIBE_TIMEOUT,
  });

  return response.data;
}

export * from './const';
